import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { CustomerSearch, CustomerSearchExternal, EditProfile, EditProfileExternal } from './siteIntegration/index';

const root = document.getElementById('root');
if (CustomerSearch && CustomerSearchExternal && EditProfile && EditProfileExternal) {
  // Making a reference to CustomerSearch so that it doesn't get
  // removed in build time tree-shaking. It is required to be present at run-time.
}
if (root !== null) {
  ReactDOM.render(
    <Router>
      <App {...window.xprops} />
    </Router>,
    root
  );
}
